/**
 * Ô chọn NHIỀU địa bàn có tìm kiếm (dùng cho "Địa bàn chia sẻ nội dung — Cấp xã"): đóng thì
 * hiện số đã chọn, mở thì có ô tìm (không phân biệt dấu), "Chọn tất cả"/"Bỏ chọn" và danh sách
 * hộp kiểm. Bấm ra ngoài hoặc Esc thì đóng.
 */
import { useEffect, useMemo, useRef, useState, type ReactNode } from 'react';
import { boDau } from './ChonDiaBanCay';

export interface MucChonNhieu {
  ma: string;
  ten: string;
}

export function ChonNhieuDiaBan({
  id,
  nhan,
  ds,
  giaTri,
  onDoi,
  goiY,
  nhanDaChon,
  nhanTatCa,
  nhanBoChon,
  goiYTim,
  khoa = false,
}: {
  id: string;
  nhan: string;
  ds: MucChonNhieu[];
  giaTri: string[];
  onDoi: (ds: string[]) => void;
  goiY: string;
  /** Mẫu "Đã chọn {so} xã". */
  nhanDaChon: (so: number) => string;
  nhanTatCa: string;
  nhanBoChon: string;
  goiYTim: string;
  khoa?: boolean;
}): ReactNode {
  const [mo, datMo] = useState(false);
  const [tim, datTim] = useState('');
  const vung = useRef<HTMLDivElement | null>(null);
  const daChon = useMemo(() => new Set(giaTri), [giaTri]);
  const loc = useMemo(() => {
    const k = boDau(tim);
    return k ? ds.filter((x) => boDau(x.ten).includes(k) || x.ma.includes(k)) : ds;
  }, [ds, tim]);

  useEffect(() => {
    if (!mo) return undefined;
    const ngoai = (e: MouseEvent): void => {
      if (vung.current && !vung.current.contains(e.target as Node)) datMo(false);
    };
    const esc = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') datMo(false);
    };
    document.addEventListener('mousedown', ngoai);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', ngoai);
      document.removeEventListener('keydown', esc);
    };
  }, [mo]);

  const bat = (ma: string): void => onDoi(daChon.has(ma) ? giaTri.filter((x) => x !== ma) : [...giaTri, ma]);
  const tenDaChon = ds.filter((x) => daChon.has(x.ma)).map((x) => x.ten);

  return (
    <div className="chon-nhieu" ref={vung}>
      <button
        type="button"
        id={id}
        className="chon-nhieu__o"
        aria-label={nhan}
        aria-expanded={mo}
        disabled={khoa}
        title={tenDaChon.join(', ') || undefined}
        onClick={() => datMo(!mo)}
      >
        <span className={giaTri.length === 0 ? 'chon-nhieu__goi-y' : undefined}>
          {giaTri.length === 0
            ? goiY
            : tenDaChon.length <= 2
              ? tenDaChon.join(', ')
              : nhanDaChon(giaTri.length)}
        </span>
        <span aria-hidden="true">▾</span>
      </button>
      {mo ? (
        <div className="chon-nhieu__hop" role="listbox" aria-multiselectable="true" aria-label={nhan}>
          <input
            type="search"
            className="chon-nhieu__tim"
            placeholder={goiYTim}
            value={tim}
            onChange={(e) => datTim(e.target.value)}
            autoFocus
          />
          <div className="chon-nhieu__nut">
            <button
              type="button"
              className="nut nut--lien-ket"
              onClick={() => onDoi([...new Set([...giaTri, ...loc.map((x) => x.ma)])])}
            >
              {nhanTatCa}
            </button>
            <button type="button" className="nut nut--lien-ket" onClick={() => onDoi([])}>
              {nhanBoChon}
            </button>
          </div>
          <ul className="chon-nhieu__ds">
            {loc.map((x) => (
              <li key={x.ma}>
                <label>
                  <input type="checkbox" checked={daChon.has(x.ma)} onChange={() => bat(x.ma)} />
                  {x.ten}
                </label>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
